<script lang="ts" setup>
	import {usePublicUrl} from "#imports";

	useHead({
		meta: [
			{ name: 'description', content: 'Die geheimen Stasi-Objekte in Leipzig: Neben den offiziellen und der Bevölkerung bekannten Dienststellen der hiesigen Stasi existierten Konspirative Wohnungen (KW) und konspirative Objekte (KO).' }
		],
	})
	const navigation = [
		{label: 'Einführung', path: '/'},
		{label: 'Projektbeschreibung', path: '/projektbeschreibung'},
		{label: 'Feldbeschreibungen', path: '/feldbeschreibungen'},
		{label: 'Beispielobjekt „Juwel“', path: '/beispielobjekt-juwel'},
		{label: 'Impressum', path: '/impressum'},
		{label: 'Datenschutz', path: '/datenschutz'},
	]
	const currentDate:Date = new Date()
	const headerBkg = usePublicUrl('/header-lg.jpg')

	const route = useRoute()
	const drawerOpen = ref(false)
	watch(route, value => {
		if(drawerOpen.value) {
			drawerOpen.value = false
		}
  	}, {deep: true, immediate: true})
</script>

<template>
	<GsApp color-mode-preference="light">
		<NuxtLayout name="site-default">

			<template #header>
				<div class="bg-primary">
					<div class="px-4">
						<div class="h-[80px] sm:h-[90px] md:h-[100px] lg:h-[120px] flex flex-row">
							<UDrawer
								direction="left"
								:ui="{
									content: 'w-full xs:w-auto max-w-none'
								}"
								v-model:open="drawerOpen"
							>
								 <div class="p-4">
								 	<LayoutBtnToggle />
								 </div>

								 <template #header>
									<h2 class="sr-only">Navigation</h2>
								</template>
								<template #body>
									<div class="w-full xs:w-80 sm:w-95 h-full relative">
										<nav role="navigation">
											<ul v-if="navigation && navigation.length" class="divide-y divide-black/50">
												<li v-for="(item,idx) in navigation" :key="idx" class="[&>a]:hover:text-accent">
													<NuxtLink :to="item.path"  no-prefetch :title="`zur Seite ${item.label}`" class="font-bold text-xl text-black hover:text-accent block px-2 py-3 sm:py-4 transition duration-300 ease-in-out">
														{{ item.label }}
													</NuxtLink>
												</li>
											</ul>
										</nav>
									</div>
								</template>
							</UDrawer>

							<div class="flex flex-row ml-auto lg:mx-auto">
								<div class="px-3 md:px-6 xl:px-12">
									<h2 class="mt-4 md:mt-5 font-title font-bold text-accent text-sm sm:text-md lg:text-xl">Bürgerkomitee Leipzig e.V.</h2>
									<p class="text-sm lg:text-[16px] hidden sm:inline-block">für die Auflösung der ehemaligen<br />Staatssicherheit (MfS)</p>
								</div>
								<img v-lazy-load  data-src="assets/img/KWL-Logo.jpg" alt="Logo" class="h-[90px] sm:h-[100px] md:h-[140px] shadow-lg" />
								<div class="px-3 md:px-6 xl:px-12 hidden lg:inline-block">
									<h2 class="mt-4 md:mt-5 font-title font-bold text-accent text-md lg:text-xl">Träger der Gedenkstätte</h2>
									<p class="text-sm lg:text-[16px]">Museum in der "Runden Ecke" mit<br />dem Museum im Stasi-Bunker</p>
								</div>
							</div>

							<div class="hidden lg:inline-block w-18"></div>

						</div>
					</div>

					<div class="h-[15px] w-full bg-primary-100"></div>
					<div class="h-[10px] w-full bg-gray"></div>

				</div>
			</template>

			<div class="relative">
				<NuxtPage/>
			</div>

			<template #footer>
				<div class="bg-black">
					<div class="px-4 lg:px-4 py-3">
						<p class="text-xs md:text-sm text-white text-center">Copyright &copy; <template v-if="currentDate">{{ currentDate.getFullYear() }} - </template>Konspirative Wohnungen Leipzig / Bürgerkomitee Leipzig e.V.</p>
					</div>
				</div>
			</template>
		</NuxtLayout>
	</GsApp>
</template>

<style>
	.page-enter-active,
	.page-leave-active {
		transition: all 0.15s;
	}
	.page-enter-from,
	.page-leave-to {
		opacity: 0;
		transform: scale(0.9);
		filter: blur(.5rem);
	}
</style>
